import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=42fa3afc&scoped=true"
import script from "./MailList.vue?vue&type=script&lang=js"
export * from "./MailList.vue?vue&type=script&lang=js"
import style0 from "./MailList.vue?vue&type=style&index=0&id=42fa3afc&prod&lang=scss"
import style1 from "./MailList.vue?vue&type=style&index=1&id=42fa3afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa3afc",
  null
  
)

export default component.exports